import axios from 'axios';
import { QueryClient } from 'react-query';
import urljoin from 'url-join';

import { useConfig } from '../../../../../_components/config';

function icdTenLookup(api: string) {
  return async (inputValue: string) => {
    let options;
    const queryClient = new QueryClient();
    const { data } = await queryClient.fetchQuery({
      queryKey: ['icdTenCodes', inputValue],
      queryFn: async () =>
        axios({
          url: urljoin(api, '/icdtencodes'),
          method: 'get',
          withCredentials: true,
          params: {
            icdTenId: inputValue || null,
          },
        }),
    });

    if (data) {
      options = data.map((m: any) => {
        const combined = `${m.code} - ${m.description}`;
        return {
          value: m.code,
          label: combined,
        };
      });
    }
    return options;
  };
}

function cptLookup(api: string) {
  return async (inputValue: string) => {
    let options;
    const queryClient = new QueryClient();
    const { data } = await queryClient.fetchQuery({
      queryKey: ['cptCodes', inputValue],
      queryFn: async () =>
        axios({
          url: urljoin(api, '/cptcodes'),
          method: 'get',
          withCredentials: true,
          params: {
            cptValue: inputValue || null,
          },
        }),
    });

    if (data) {
      options = data.map((m: any) => {
        const combined = `${m.cptCode} - ${m.description}`;
        return {
          value: m.cptCode,
          label: combined,
        };
      });
    }
    return options;
  };
}

export default function useLookup() {
  const { api } = useConfig();
  return { icdTenLookup: icdTenLookup(api), cptLookup: cptLookup(api) };
}
